import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  ANALYTICS_CONSENT_UPDATED_EVENT,
  COOKIE_SETTINGS_OPEN_EVENT,
  clearAnalyticsConsent,
  getAnalyticsConsent,
  getAnalyticsConsentStatusLabel,
  initializeAnalyticsIfConsented,
  sendPageViewIfConsented,
  setAnalyticsConsent,
} from './analyticsConsent';

const CookieConsentBanner = () => {
  const [decision, setDecision] = useState(getAnalyticsConsent());
  const [isOpen, setIsOpen] = useState(!getAnalyticsConsent());

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const syncDecision = () => {
      const nextDecision = getAnalyticsConsent();
      setDecision(nextDecision);
      return nextDecision;
    };

    const handleConsentUpdated = () => {
      const nextDecision = syncDecision();
      setIsOpen(!nextDecision);
    };

    const handleOpenSettings = () => {
      syncDecision();
      setIsOpen(true);
    };

    window.addEventListener(ANALYTICS_CONSENT_UPDATED_EVENT, handleConsentUpdated);
    window.addEventListener(COOKIE_SETTINGS_OPEN_EVENT, handleOpenSettings);

    return () => {
      window.removeEventListener(ANALYTICS_CONSENT_UPDATED_EVENT, handleConsentUpdated);
      window.removeEventListener(COOKIE_SETTINGS_OPEN_EVENT, handleOpenSettings);
    };
  }, []);

  const handleDecision = value => {
    setAnalyticsConsent(value);
    setDecision(value);
    setIsOpen(false);

    if (value === 'granted') {
      initializeAnalyticsIfConsented();
      sendPageViewIfConsented(window.location.pathname);
    }
  };

  const handleReset = () => {
    clearAnalyticsConsent();
    setDecision(null);
    setIsOpen(true);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="consent-banner" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <div className="consent-copy">
        <strong>Privacy choices</strong>
        <p>
          101Setups uses optional analytics to understand how the site is used and improve it. You can accept, reject,
          or later change non-essential analytics. Read our <Link to="/privacy">Privacy Policy</Link> and{' '}
          <Link to="/cookies">Cookie Policy</Link>.
        </p>
        {decision ? (
          <p className="consent-status">Current setting: Analytics {getAnalyticsConsentStatusLabel(decision)}.</p>
        ) : null}
      </div>
      <div className="consent-actions">
        {decision ? (
          <button className="consent-button tertiary" onClick={handleReset}>
            Reset choice
          </button>
        ) : null}
        <button className="consent-button secondary" onClick={() => handleDecision('denied')}>
          Reject analytics
        </button>
        <button className="consent-button primary" onClick={() => handleDecision('granted')}>
          Accept analytics
        </button>
        {decision ? (
          <button className="consent-button tertiary" onClick={() => setIsOpen(false)}>
            Close
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default CookieConsentBanner;
